import React from 'react';
import Checkbox from '../../checkbox';
import TicketStub from '../';
import SeatWaveHeader from '../seatwave_header';
import TicketStubContent from '../content';
import TicketStubOutline from '../outline';
import TicketStubSidebar from '../side_bar';
import TicketStubInfo from '../ticket_stub_info';
import translate from '../../../../utils/translate';
import U from '../ticket_stub_utils';

const T = React.PropTypes;

export default class MyAccountTemplate extends React.Component {
  static propTypes = {
    ticket: T.object,
    onClick: T.func,
    children: T.node
  };

  renderSeatwaveRow = (ticket) => {
    if (ticket.secondaryMarketStatus === U.LISTED_ON_SECONDARY_MARKET) {
      return (
        <SeatWaveHeader
          header={translate('upcomingEventsModule', 'SECONDARY_MARKET_TICKET_STATUS')}
          text={translate('upcomingEventsModule', 'LISTED_FOR_SALE_ON_SECONDARY_MARKET')} />
      );
    }

    if (ticket.secondaryMarketStatus === U.SOLD_ON_SECONDARY_MARKET) {
      return (
        <SeatWaveHeader
          isDisabled
          header={translate('upcomingEventsModule', 'SECONDARY_MARKET_TICKET_STATUS')}
          text={translate('upcomingEventsModule', 'SOLD_ON_SECONDARY_MARKET')} />
      );
    }

    return false;
  };

  render () {
    const type = this.props.ticket.isSelected ? 'ticket_list_item_active' : 'ticket_list_item';

    return <TicketStub dataComponent={this.props.ticket.seat_id}>
      <TicketStubOutline
        isBlue={!this.props.ticket.isSelected && !U.isDisabled(this.props.ticket)}
        isGreen={this.props.ticket.isSelected}
        ovalColorClass="ticket_stub_outline__oval--my_tickets_gray" />
      <TicketStubContent dataComponent={type}>
        <TicketStubSidebar>
          { (this.props.ticket.downloadable && !U.isDisabled(this.props.ticket)) &&
          <Checkbox checked={this.props.ticket.isSelected} onChange={this.props.onClick} />
          }
        </TicketStubSidebar>
        <TicketStubInfo>
          {this.renderSeatwaveRow(this.props.ticket)}
          {this.props.children}
        </TicketStubInfo>
      </TicketStubContent>
    </TicketStub>;
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/ticket_stub/templates/my_account_template.js